


import { Outlet } from 'react-location';
import Joyride from 'react-joyride';
import { useTutorial } from './context/TutorialContext';




function App() {

  const steps = useTutorial((state) => state.steps);
  const handleCallback = useTutorial((state) => state.handleCallback);
  const run = useTutorial((state) => state.run);
  const stepIndex = useTutorial((state) => state.stepIndex);

  return (
 
      <>
   <Outlet />
   <Joyride
   callback={handleCallback}
   continuous
   run={run}
   stepIndex={stepIndex}
   steps={steps}
   disableScrollParentFix={true}
  
  //  styles={
  //   {
  //     overlay: { height: '100%' }, // Fix for random scroll issue
  //   }
  //  }
    />
    </>
  );
}

export default App;
